module.exports = __webpack_public_path__ + "static/media/clutch_logo.abcc34c8.png";